import { createSelector } from '@reduxjs/toolkit';
import { name } from './slice';
import type { CustomerSlice, CustomerStateType } from './types';
import { CustomerSchemaInternational, CustomerSchemaRu } from './schema';

export const customerSliceSelector = (state): CustomerSlice => state[name];

export const customerInfoSelector = (state) =>
  customerSliceSelector(state).customer;

export const mobileCustomerFormVisibleSelector = (state) =>
  customerSliceSelector(state)?.customerFormShown || false;

// Преобразовываем поля для отправки на бэкенд
export const customerInfoSelectorTransformed = (state) => {
  const customerInfo = customerInfoSelector(state);
  const { nationalityId, passportNumber, docType, ...other } = customerInfo;

  return {
    nationality_id: nationalityId,
    passport_number: passportNumber,
    doc_type: docType,
    ...other,
  };
};

export const isCustomerInfoValidSelector = createSelector(
  customerInfoSelector,
  (customer: CustomerStateType) =>
    customer.docType === 'internal_passport'
      ? CustomerSchemaRu.isValidSync(customer)
      : CustomerSchemaInternational.isValidSync(customer),
);

export const showFillerButtonSelector = (state, tourist) => {
  const customer = customerInfoSelector(state);

  if (tourist?.docType === 'internal_passport') {
    return customer?.docType === 'internal_passport';
  }
  return false;
};
